var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.adNetworks)?_c('div',{class:_vm.$style.wrapper},_vm._l((_vm.adNetworks),function(adNetwork){return _c('img',{key:adNetwork,attrs:{"src":_vm.getIcon(adNetwork)}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }